/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import RecentView from 'chat/components/RecentView.jsx';
import { showRecent, hideRecent } from 'reducers/recentMessagesModal';

type Props = {
  showingRecent: boolean,
  showRecent: Function,
  hideRecent: Function,
};

class RecentViewListener extends React.Component<Props> {
  show = () => {
    this.props.showRecent();
  };
  hide = () => {
    this.props.hideRecent();
  };
  render() {
    if (!this.props.showingRecent) {
      return null;
    }

    return <RecentView hide={this.hide} />;
  }
}

function mapStateToProps(state: Object) {
  return {
    showingRecent: state.recentMessagesModal.showingRecent,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ showRecent, hideRecent }, dispatch);
}

export { RecentViewListener };
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RecentViewListener);
